import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { ActionTypeEnum, OptionsType, SELECT_ALL_ID } from '../../constants';
import StyledSelect from '../StyledSelect/index';

/*
    This code works when built with webpack using development mode.

    It does not behave correctly when built using production mode.

    The exact reason is unclear, although I suspect it has something to do with
      webpack's minification process
*/

const isInMenuList = el => {
  const menuList = document.querySelector('[class*="MenuList"]');
  return menuList && (menuList.isSameNode(el) || menuList.contains(el));
};

const isRemoveValueIcon = el =>
  (el && el.classList.value && typeof el.classList.value === 'string' && el.classList.value.endsWith('Svg')) ||
  (el.nearestViewportElement &&
    el.nearestViewportElement.classList.value &&
    typeof el.nearestViewportElement.classList.value === 'string' &&
    el.nearestViewportElement.classList.value.endsWith('Svg'));

/**
 * @internal
 */
const ControlledMultiSelect = ({ ...props }) => {
  const [hasBeenCleared, setHasBeenCleared] = useState(false);
  const [hasFocus, setHasFocus] = useState(false);
  const [shouldTriggerClick, setShouldTriggerClick] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(props.menuIsOpen);

  const handleClick = event => {
    if (shouldTriggerClick && !isInMenuList(event.target) && !isRemoveValueIcon(event.target)) {
      setIsMenuOpen(!isMenuOpen);
    }

    if (hasFocus && !shouldTriggerClick) {
      setShouldTriggerClick(true);
    }
  };

  const handleChange = (values, meta) => {
    if (
      (meta.action === ActionTypeEnum.SELECT_OPTION && meta.option.id === SELECT_ALL_ID) ||
      (values && values.length === props.options.filter(({ id }) => id !== SELECT_ALL_ID).length)
    ) {
      setIsMenuOpen(false);
    }

    if (meta.action === ActionTypeEnum.CLEAR) {
      setHasBeenCleared(true);
    }

    if (props.onChange) {
      props.onChange(values, meta);
    }
  };

  const handleBlur = event => {
    setHasFocus(false);
    setShouldTriggerClick(false);
    setIsMenuOpen(false);

    if (props.onFocus) {
      props.onBlur(event);
    }
  };

  const handleFocus = event => {
    setHasFocus(true);

    if (hasBeenCleared) {
      setHasBeenCleared(false);
      setShouldTriggerClick(true);
    } else {
      setIsMenuOpen(true);
    }

    if (props.onFocus) {
      props.onFocus(event);
    }
  };

  const updatedProps = {
    ...props,
    menuIsOpen: isMenuOpen,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
  };

  return (
    <Grid onClick={handleClick} role="none">
      <StyledSelect {...updatedProps} />
    </Grid>
  );
};

ControlledMultiSelect.propTypes = {
  menuIsOpen: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  options: OptionsType,
};

ControlledMultiSelect.defaultProps = {
  menuIsOpen: false,
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
};

/**
 * @internal
 */
export default ControlledMultiSelect;
